export const HeadHuntings = [
  {
    name: 'Shally Xu',
    qrcode: 'shally',
  },
  {
    name: 'Tommy Li',
    qrcode: 'tommy',
  },
  {
    name: 'Annie Bao',
    qrcode: 'annie',
  },
  {
    name: 'Nathan Yu',
    qrcode: 'nathan',
  },
  {
    name: 'Karen Wang',
    qrcode: 'karen',
  },
  {
    name: '林志东',
    qrcode: 'linzhidong',
  },
  {
    name: 'Tina Chu',
    qrcode: 'tinachu',
  },
  {
    name: 'Helen Lan',
    qrcode: 'helen',
  },
  {
    name: 'Wendy Liu',
    qrcode: 'wendy',
  },
  {
    name: '王琳',
    qrcode: 'elin',
  },
  {
    name: 'Aki Wu',
    qrcode: 'aki',
  },
  {
    name: 'Tina Liao',
    qrcode: 'tinaliao',
  },
  {
    name: 'Emily Tang',
    qrcode: 'emily',
  },
]
